// extracted by mini-css-extract-plugin
module.exports = {"Completion":"completion_Completion__3mdh4","Heading":"completion_Heading__2c9WF","InfoText":"completion_InfoText__i3YdV","ButtonContainer":"completion_ButtonContainer__wwPy1"};